(function(){
  function iconSVG(kind){
    var icons = {
      instagram:
        '<svg class="nm-social-icon nm-social-icon--instagram" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
          '<defs>' +
            '<linearGradient id="nmig28" x1="10" y1="54" x2="54" y2="10" gradientUnits="userSpaceOnUse">' +
              '<stop offset="0" stop-color="#f9ce34"/>' +
              '<stop offset="0.42" stop-color="#ee2a7b"/>' +
              '<stop offset="0.72" stop-color="#6228d7"/>' +
              '<stop offset="1" stop-color="#4f5bd5"/>' +
            '</linearGradient>' +
          '</defs>' +
          '<circle cx="32" cy="32" r="28" fill="#edf5fb"/>' +
          '<path d="M22.2 13.8h19.6c4.6 0 8.4 3.8 8.4 8.4v19.6c0 4.6-3.8 8.4-8.4 8.4H22.2c-4.6 0-8.4-3.8-8.4-8.4V22.2c0-4.6 3.8-8.4 8.4-8.4Z" fill="url(#nmig28)"/>' +
          '<rect x="20.5" y="20.5" width="23" height="23" rx="7.3" fill="none" stroke="#fff" stroke-width="4.5"/>' +
          '<circle cx="32" cy="32" r="6.2" fill="none" stroke="#fff" stroke-width="4.5"/>' +
          '<circle cx="43.2" cy="20.8" r="2.5" fill="#fff"/>' +
        '</svg>',
      tiktok:
        '<svg class="nm-social-icon nm-social-icon--tiktok" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
          '<circle cx="32" cy="32" r="28" fill="#edf5fb"/>' +
          '<path d="M35.7 16.5c2 3.1 4.7 5 8.7 5.6v4.9a16.5 16.5 0 0 1-8.7-2.7v12.8c0 7-5.5 12.4-12.9 12.4-5.2 0-9.2-2.4-11.4-6.3 1.8 1 3.8 1.6 5.9 1.6 5 0 8.9-3.6 8.9-8.5V16.4h9.5v.1Z" fill="#111"/>' +
          '<path d="M37.7 18.8c1.5 2.1 3.5 3.5 6.7 4v2.6a12.7 12.7 0 0 1-6.7-2v13.8c0 7-5.5 12.4-12.9 12.4-2.8 0-5.4-.6-7.6-1.9 1.5.4 2.8.6 4.1.6 5 0 8.9-3.6 8.9-8.5V18.7h7.5Z" fill="#00d8e0"/>' +
          '<path d="M35.9 17.5c1.7 2.5 4 4.1 7.4 4.7v3.4a13.8 13.8 0 0 1-7.4-2.3v13.2c0 6.8-5.4 12.1-12.5 12.1-2.7 0-5.2-.6-7.3-1.8 1.4.4 2.7.5 3.9.5 4.8 0 8.6-3.5 8.6-8.2V17.4h7.3Z" fill="#1f7ed6" opacity=".95"/>' +
        '</svg>',
      whatsapp:
        '<svg class="nm-social-icon nm-social-icon--whatsapp" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
          '<circle cx="32" cy="32" r="28" fill="#edf5fb"/>' +
          '<circle cx="32" cy="32" r="16.2" fill="#2ecb71"/>' +
          '<path d="M32 21.2c-5.9 0-10.7 4.7-10.7 10.5 0 1.9.5 3.8 1.5 5.4l-1.2 5 5.1-1.3c1.6.8 3.4 1.2 5 1.2 5.9 0 10.8-4.7 10.8-10.6 0-5.8-4.9-10.2-10.5-10.2Z" fill="#fff"/>' +
          '<path d="M37.7 34.9c-.4-.2-2.3-1.1-2.6-1.2-.4-.1-.6-.2-.8.2l-.8 1c-.2.3-.4.3-.7.2-1.7-.7-3.2-1.9-4.3-3.5-.2-.3 0-.5.1-.7l.7-.7c.2-.2.3-.4.4-.6 0-.2 0-.4-.1-.6l-1.1-2.5c-.2-.5-.5-.5-.8-.5h-.7c-.3 0-.6.1-.9.5-.4.4-1.2 1.3-1.2 3.1s1.2 3.5 1.5 3.8c.2.3 2.4 3.8 6.1 5.2 3.6 1.4 3.6.7 4.3.7.7 0 2.4-1 2.8-2 .4-1 .4-1.8.2-2-.1-.2-.4-.3-.8-.5Z" fill="#2ecb71"/>' +
        '</svg>',
      facebook:
        '<svg class="nm-social-icon nm-social-icon--facebook" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
          '<circle cx="32" cy="32" r="28" fill="#edf5fb"/>' +
          '<path d="M37.3 49V33.5h5.3l.8-5.8h-6.1V24c0-1.7.5-2.8 3.1-2.8h3v-5.6c-.5-.1-2.5-.2-4.5-.2-5.4 0-9 3.2-9 9v3.4h-5.7v5.8h5.7V49h7.4Z" fill="#1f7ed6"/>' +
        '</svg>'
    };
    return icons[kind] || '';
  }

  function detectKind(url){
    var u = (url || '').toLowerCase();
    if (u.indexOf('instagram') > -1) return 'instagram';
    if (u.indexOf('tiktok') > -1) return 'tiktok';
    if (u.indexOf('whatsapp') > -1 || u.indexOf('wa.me') > -1 || u.indexOf('api.whatsapp.com') > -1) return 'whatsapp';
    if (u.indexOf('facebook') > -1 || u.indexOf('fb.com') > -1) return 'facebook';
    return '';
  }

  function renderSoftIcons(){
    var modules = document.querySelectorAll('.sidebar-module.nm-contact-sidebar');
    modules.forEach(function(module){
      var content = module.querySelector(':scope > div:last-child');
      if (!content) return;
      var links = Array.prototype.slice.call(content.querySelectorAll('a'));
      var socials = [];
      links.forEach(function(a){
        var kind = detectKind(a.getAttribute('href') || '');
        if (!kind) return;
        if (socials.some(function(s){ return s.kind === kind; })) return;
        socials.push({ kind: kind, href: a.href });
        var holder = a.closest('p') || a;
        holder.classList.add('nm-contact-social-source');
      });
      if (!socials.length) return;
      var row = content.querySelector('.nm-contact-socials');
      if (!row){
        row = document.createElement('div');
        row.className = 'nm-contact-socials';
        content.appendChild(row);
      }
      row.innerHTML = socials.map(function(item){
        return '<a href="' + item.href + '" target="_blank" rel="noopener noreferrer" aria-label="' + item.kind + '">' + iconSVG(item.kind) + '</a>';
      }).join('');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderSoftIcons);
  } else {
    renderSoftIcons();
  }
  window.addEventListener('load', renderSoftIcons);
  setTimeout(renderSoftIcons, 1200);
})();
